import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { CrudService } from '@shared/services/base/crud.service';
import { MessagesService, NotificationType } from '@shared/services/message.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UsuarioModel } from '../model/usuario.model';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService extends CrudService<UsuarioModel> implements Resolve<UsuarioModel> {
  constructor(http: HttpClient, message: MessagesService) {
    super(http, message);
  }

  baseUrl(): string {
    return 'usuario';
  }

  gestao(user: UsuarioModel, username: string): Observable<UsuarioModel> {
    const url = `${this.baseUrl()}/${username}/gestao`;
    return this.http.post<UsuarioModel>(url, user);
  }

  resolve(route: ActivatedRouteSnapshot): Observable<UsuarioModel> {
    return this.get(route.params.username);
  }

  saveUser(user: UsuarioModel): Promise<UsuarioModel> {
    return this.saveAndNotify(user, null);
  }

  updateUser(user: UsuarioModel, username): Promise<UsuarioModel> {
    return this.saveAndNotify(user, username);
  }

  resetPassword(passwords: { senhaAtual: string; novaSenha: string }, id: string): Observable<void> {
    const url = `${this.baseUrl()}/${id}/reset-password`;
    return this.http.post<void>(url, passwords).pipe(
      tap(() => {
        this.message.notifyI18n('general.messages.changed_password', NotificationType.Success);
      }),
    );
  }

  state(id: string, state: boolean) {
    return this.http.put(this.baseUrl() + '/' + id + '/activation?state=' + state, {});
  }
}
